import React from "react";
import { Link } from "react-router-dom";

export default function BrandHeader() {
  return (
    <div className="max-w-[1360px] mx-auto px-7 h-[76px] flex items-center">
      <Link to="/" className="inline-block">
        <img src="/voleor-logo.png" alt="Voleor" className="h-[27px] w-auto" />
      </Link>
    </div>
  );
}
